import { render, staticRenderFns } from "./NetdocBCD.vue?vue&type=template&id=3f930e46&scoped=true"
import script from "./NetdocBCD.vue?vue&type=script&lang=js"
export * from "./NetdocBCD.vue?vue&type=script&lang=js"
import style0 from "./NetdocBCD.vue?vue&type=style&index=0&id=3f930e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f930e46",
  null
  
)

export default component.exports